
<v-card
    :ripple="false"
    @click = "onSelectd"
    flat
>
    <div style="height: 25px" >
        <div class="v-flex w-100">
            <div style="margin-top: -2px; margin-right: -10px;" class="mr-1">
                <c-site-icon
                    :site="unit"
                    @selected="onSite"
                />
            </div>
            <div class="v-flex" style="width: calc(100% - 25px)">
                <div
                    class="mr-1 unit-name"
                    style="min-width: 120px"
                    :class="active ? '' : 'lightgray'"
                >
                    {{ unit.fabricNo }}
                </div>
                <div
                    class="unit-location"
                    :class="active ? '' : 'lightgray'"
                >
                    {{ unit.city }}, {{ unit.street }}
                </div>
            </div>
        </div>
    </div>
</v-card>
